import { useEffect, useRef, useState } from "react";

const DEFAULT_BOTTOM_MARGIN = 16;

export function useDrawerTableContainerHeight(bottomMargin = DEFAULT_BOTTOM_MARGIN) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [tableHeight, setTableHeight] = useState<number | undefined>();

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const updateHeight = () => {
      setTableHeight(Math.max(200, element.clientHeight - bottomMargin));
    };

    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(element);
    return () => observer.disconnect();
  }, [bottomMargin]);

  return { containerRef, tableHeight };
}

export function getShrinkToContentListHeight(rowCount: number, rowHeight: number): number {
  if (rowCount <= 0) return 40;
  return rowCount * rowHeight + 2;
}
